export function pickNextRotationIndex(
	length: number,
	currentIndex: number,
	random: () => number = Math.random,
): number {
	if (length <= 1) {
		return 0;
	}

	const offset = Math.floor(random() * (length - 1));

	return offset >= currentIndex ? offset + 1 : offset;
}
